import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { L1L3AuthService } from 'ngx-auth-util-lib';
import { HekaAccountMenu } from 'ngx-heka-design-lib';
import { Subscription } from 'rxjs';
import { AccountMenuService } from 'src/app/services/account-menu.service';
import { DomainHandlerService } from 'src/app/services/domain-handler-service';
import { MultiDomainMgmtService } from 'src/app/services/multi-domain-mgmt.service';
import { environment } from '../../../environments/local/environment';
import {LoadingService} from "../../services/loading/loading.service";

@Component({
  selector: 'ngx-l2-minimal-menu-bar',
  templateUrl: './l2-minimal-menu-bar.component.html',
  styleUrls: ['./l2-minimal-menu-bar.component.scss'],
  standalone: false
})
export class L2MinimalMenuBarComponent implements AfterViewInit, OnDestroy {
  accountMenu?: HekaAccountMenu;
  env = environment;

  private subscriptions = new Subscription();

  constructor(
    public loadingService: LoadingService,
    public authService: L1L3AuthService,
    public accountMenuService: AccountMenuService,
    public multiDomainMgmtService: MultiDomainMgmtService,
    public domainHandlerService: DomainHandlerService
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.subscriptions.add(
        this.multiDomainMgmtService.getSharedMultiDomainProfile().subscribe({
          next: profile => {
            if (profile) {
              this.accountMenu = this.accountMenuService.buildAccountMenu(profile);
            }
          }
        })
      );
      this.multiDomainMgmtService.getMultiDomainProfile().subscribe();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
